<template>
  <el-select
    :value="value"
    @input="$emit('input', $event)"
    :placeholder="placeholder"
    clearable
    @change="changeHanlder"
    :style="{
      width: this.width,
    }"
  >
    <el-option :key="false" :label="falseLabel" :value="false"> </el-option>
    <el-option :key="true" :label="trueLabel" :value="true"> </el-option>
  </el-select>
</template>
<script>
export default {
  name: "BooleanSelect",
  props: {
    value: [Number, String, Boolean],
    placeholder: {
      type: String,
      default: "请选择",
    },
    width: {
      type: [Number, String],
      default: "180px",
    },
    trueLabel: {
      type: String,
      default: "是",
    },
    falseLabel: {
      type: String,
      default: "否",
    },
  },
  data() {
    return {};
  },
  methods: {
    changeHanlder(val) {
      this.$emit("change", typeof val =='boolean' ? val : null);
    },
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/fm/BooleanSelect.vue